import React, { ReactElement, useEffect, useState } from 'react';
import {
  Breadcrumbs, HiddenPriorityTitle, homeBreadcrumb, Message,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import routes from '../../routing/routes';
import Layout from '../Layout';
import { useClient } from '../../context/ClientStatusContext';
import { getVyhlasovanieVZbierke } from '../../client/vyhlasovanieVZbierkeClient';
import insertScripts from '../../function/insertScripts';
import VyhlasovanieVZbierke from '../../module/VyhlasovaniePravnychPredpisov';

const VyhlasovanieVZbierkePage = (): ReactElement => {
  const {
    data,
    status,
  } = useClient(
    () => getVyhlasovanieVZbierke(),
  );
  const [displayError, setDisplayError] = useState(true);

  useEffect(() => {
    if (data) {
      insertScripts([
        `${process.env.REACT_APP_SUBPATH}js/linkHandler.js`,
      ]);
    }
  }, [data]);

  return (
    <Layout>
      <HiddenPriorityTitle>Vyhlasovanie v Zbierke zákonov SR</HiddenPriorityTitle>
      <Breadcrumbs
        routeList={[
          homeBreadcrumb(process.env.REACT_APP_STATICKY_OBSAH_URL as string),
          {
            to: routes.vyhlasovanieVZbierke.to,
            heading: routes.vyhlasovanieVZbierke.name,
          },
        ]}
      />
      <Loader loading={status.loading}>
        {(status.responseCode && status.responseCode > 399) ? (
          <>
            {displayError && (
            <Message
              type="error"
              onClear={() => setDisplayError(false)}
              headingSize="m"
            >
              Nepodarilo sa načítať vyhlasovanie v Zbierke zákonov SR.
            </Message>
            )}
          </>
        )
          : (
            <VyhlasovanieVZbierke
              text={data}
            />
          )}
      </Loader>
    </Layout>
  );
};

export default VyhlasovanieVZbierkePage;
